import { Section } from 'app/common/metadata-models/section';

// Mock data used for development and testing.
export class MockSections {
    public sections: Section[] = [
        new Section({
            id: 'Examples',
            sectionName: 'Examples',
            isSaved: true,
            alwaysSave: false
        })
    ];
}
